export default "__VITE_ASSET__CxuqW$Vq__"